export const links = {
  booking: 'https://cal.com/craig-thomas-f2ucgl/30min?overlayCalendar=true',
  linkedin: 'https://www.linkedin.com/in/craig-thomas-1450b66/',
  portrait:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/8oFFmEna3CRhNnzzoDmmFQ/1545923747529.jpg',
}

export const navItems = [
  { label: 'How I Help', id: 'how-i-help' },
  { label: 'How I Work', id: 'how-i-work' },
  { label: 'Experience', id: 'experience' },
  { label: 'About', id: 'about' },
]

export const situations = [
  {
    title: 'An important initiative is stuck',
    body: 'The priority is clear, but progress keeps slipping. I help clarify decisions, establish ownership, and lead the work through implementation.',
  },
  {
    title: 'Your leadership team needs to work better together',
    body: 'Unclear roles, unresolved disagreements, or inconsistent follow-through are holding the organization back. I help leaders build shared expectations and more effective ways of working.',
  },
  {
    title: 'Your operations need to catch up',
    body: 'Growth or change has stretched the systems and habits that used to work. I help simplify processes, strengthen accountability, and connect daily work to organizational priorities.',
  },
  {
    title: 'You’re navigating a transition',
    body: 'A leadership change or shift in direction requires experienced support. I bring hands-on leadership while helping the team build the capacity for what comes next.',
  },
]

export const steps = [
  {
    number: '01',
    title: 'Find the real constraint',
    body: 'I listen, ask questions, and look at how work actually happens. Together, we identify where strategy, leadership, structure, or systems are limiting progress and decide what matters most.',
  },
  {
    number: '02',
    title: 'Work alongside your team',
    body: 'I take an active role in implementation: facilitating decisions, clarifying responsibilities, improving operations, and coaching leaders as the work moves forward. Where useful, I use AI and automation to accelerate analysis, prototyping, process improvement, and implementation.',
  },
  {
    number: '03',
    title: 'Build the capacity to carry it forward',
    body: 'We establish clear ownership, practical systems, and stronger leadership habits. Knowledge and responsibility transfer to your team throughout the engagement.',
  },
]

export const experience = [
  {
    org: 'Fully',
    title: 'Scaling an organization without losing operational control',
    body: 'Led through rapid growth, international expansion, acquisition, and major organizational change. Built the operating systems, leadership structure, and processes required to support a business that grew more than 6x over 5 years.',
  },
  {
    org: 'Mission-Driven Organization',
    title: 'Strategic alignment that became an executive transition',
    body: 'A six-month, part-time engagement with a roughly $30M mission-driven organization began with strategy-to-execution work and expanded into a senior finance leadership transition, role redesign, executive search, organization-wide workplanning and budgeting, and a cross-functional values process.',
  },
  {
    org: 'Consulting engagements',
    title: 'Fixing the constraint, not just advising on it',
    body: 'Helped owners and leadership teams address cash pressure, profitability, supply-chain leverage, operating complexity, and consequential business decisions, often moving from diagnosis into hands-on implementation.',
  },
]
